// Pure helpers for Scan templates: ready-made starters, what a template stores, and the requests it starts.
import { DEFAULT_OPTIONS, DEPTHS as WEB_DEPTHS, buildScanRequests, scanLabel } from './webScanLogic';
import { CARE, KINDS, buildNetworkRequests, kindLabel } from './networkScanLogic';

export const FAMILIES = { web: 'Web', network: 'Network' };
export const FAMILY_COLOR = { web: '#22c55e', network: '#f59e0b' };

// What a template keeps in `metadata`: web = depth, network = kind + care. `note` is a free-text description.
export const STARTERS = [
  { key: 'quick-web', name: 'Quick website check', family: 'web', note: 'Basic headers and common mistakes in a couple of minutes.', depth: 'quick', letter: 'W' },
  { key: 'deep-web', name: 'Deep website audit', family: 'web', note: 'Crawl every page, read JavaScript and include subdomains. Takes longer.', depth: 'deep', letter: 'D' },
  { key: 'ports', name: 'Open ports sweep', family: 'network', note: 'See which ports answer on each host.', kind: 'network_port_scan', care: 'balanced', letter: 'P' },
  { key: 'services', name: 'Services and banners', family: 'network', note: 'What runs behind each open port.', kind: 'network_service_scan', care: 'balanced', letter: 'S' }
];

export const toPayload = ({ name, family, note, depth, kind, care, shared }) => {
  const metadata = family === 'web' ? { note, depth } : { note, kind, care };
  return { name: name.trim(), scan_type: family, shared: Boolean(shared), metadata, yaml_config: toText(family, metadata), checks_count: 1 };
};

export const toText = (family, m) => (family === 'web'
  ? `scan: ${WEB_DEPTHS.find((d) => d.id === m.depth)?.type || 'web_crawl'}\ndepth: ${m.depth}`
  : `scan: ${m.kind}\ncare: ${m.care}`);

// Chips shown on a card, e.g. ['Web crawl', 'Balanced'].
export function tags(t) {
  const m = t.metadata || {};
  if (t.scan_type === 'web') { const d = WEB_DEPTHS.find((x) => x.id === m.depth); return d ? [scanLabel(d.type), d.title] : []; }
  if (t.scan_type === 'network') { const c = CARE.find((x) => x.id === m.care); return m.kind ? [kindLabel(m.kind), c?.title].filter(Boolean) : []; }
  return [];
}

// Only templates with saved settings for Web or Network can be run from this page.
export const canRun = (t) => tags(t).length > 0;

// One request per picked address. `rows` come from the ScopePicker ({id, value, label, kind}).
export function buildRuns(t, userTargetId, rows) {
  const m = t.metadata || {};
  if (t.scan_type === 'web') {
    const d = WEB_DEPTHS.find((x) => x.id === m.depth);
    return buildScanRequests({ scanType: d.type, options: { ...DEFAULT_OPTIONS, ...d.options }, authProfileId: '', userTargetId, targets: rows });
  }
  return buildNetworkRequests({ kind: m.kind, care: m.care, userTargetId, hosts: rows });
}

export const filterTemplates = (list, family, q) => {
  const s = q.trim().toLowerCase();
  return list.filter((t) => (family === 'all' || t.scan_type === family) && (!s || `${t.name} ${t.metadata?.note || ''}`.toLowerCase().includes(s)));
};
export { KINDS, CARE, WEB_DEPTHS };
